<script setup lang="ts">
import SchemaInfoCard from "@/components/task-pane/SchemaInfoCard.vue";
import { useApiStore } from "@/stores/api/useApiStore";
import { storeToRefs } from "pinia";

const apiStore = useApiStore();
const { loadingApiEntries, loadedApiEntries, visibleApiEntries } = storeToRefs(apiStore);

function getApiName(entry: (typeof loadingApiEntries.value)[number]): string {
  return typeof entry.item === "object" ? entry.item.name : entry.url;
}
</script>

<template>
  <v-card class="d-flex flex-column flex-1-1 bg-transparent" elevation="0" flat>
    <v-card-text class="d-flex flex-column flex-1-1 pa-0">
      <div v-for="entry in loadingApiEntries" :key="`loading-${entry.url}`" class="mb-4">
        <v-card class="rounded-lg bg-primaryContainer pa-3 pb-0" elevation="0" flat>
          <v-card-title class="d-flex align-center pa-0 equation-type-title">
            <v-progress-circular indeterminate size="16" width="2" class="mr-2 flex-shrink-0" />
            <span class="text-truncate">Loading {{ getApiName(entry) }}...</span>
          </v-card-title>
          <v-card-text class="pa-0">
            <v-skeleton-loader class="bg-transparent pa-0" type="text, text, chip" :loading="true" />
          </v-card-text>
        </v-card>
      </div>

      <SchemaInfoCard
        v-for="entry in loadedApiEntries"
        :key="entry.url"
        class="rounded-lg bg-primaryContainer mb-4"
        :url="entry.url"
      />

      <v-card
        v-if="visibleApiEntries.length === 0"
        class="rounded-lg bg-primaryContainer text-center pa-3"
        elevation="0"
        flat
      >
        <v-icon size="48" color="secondary"> mdi-checkbox-multiple-blank-outline </v-icon>
        <v-card-title class="equation-type-title">Nothing available yet</v-card-title>
        <v-card-subtitle class="equation-type-body">Choose one or more items from the top to begin.</v-card-subtitle>
      </v-card>
    </v-card-text>
  </v-card>
</template>
